export const BOOKING_URL = "#enquire";

export const CONTACT = {
  email: "barksandcogrooming@gmail.com",
  location: "Auckland, New Zealand · Exact address provided upon booking confirmation",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/jeihj0lu_Screenshot%202026-05-10%20at%2011.11.14%E2%80%AFPM.png";

export const SOCIALS = {
  instagram: "https://www.instagram.com/barksandco.nz/",
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/el7ttp30_dog%20groomw.jpg",
  about:
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/dz1g2iau_c75aa35d507eab202918bc55ff504349.jpg",
  gallery: [
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dog-spa-home/artifacts/wuo56kri_Screenshot%202026-09-29%20at%201.38.37%E2%80%AFPM.png",
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dog-spa-home/artifacts/aawc0a09_Screenshot%202026-09-29%20at%201.40.27%E2%80%AFPM.png",
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/el7ttp30_dog%20groomw.jpg",
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/u276sxlc_226d2db6216d1dcc51b6927b3ac50aeb.jpg",
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/qsxgkr87_03c8c797a71adb99fc2b7fbdc67e7cdc.jpg",
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/ympo61vk_91eb658cbf2ec4f1de1fc3524142d189.jpg",
    "https://customer-assets.emergentagent.com/job_dog-spa-home/artifacts/dz1g2iau_c75aa35d507eab202918bc55ff504349.jpg",
  ],
};

export const SERVICES = [
  {
    title: "Full Groom",
    description:
      "A complete spa experience — bath, blow-dry, breed-tailored haircut, ear clean, nail trim and finishing scent. Suited to most breeds.",
    duration: "2 – 3 hours",
    icon: "scissors",
  },
  {
    title: "Bath & Tidy",
    description:
      "Premium bath, hand-fluff dry, sanitary tidy, paw pad trim, ear clean and nail trim — perfect between full grooms.",
    duration: "1.5 – 2 hours",
    icon: "droplets",
  },
  {
    title: "Puppy's First Groom",
    description:
      "A gentle, patient introduction for pups under 6 months. Bath, blow-dry, light tidy and lots of cuddles to build positive habits for life.",
    duration: "1 – 1.5 hours",
    icon: "heart",
  },
  {
    title: "Nail Trim & Tidy",
    description:
      "Quick nail trim with a smooth file finish, plus paw pad and sanitary trim. In and out, calm and stress-free.",
    duration: "20 – 30 mins",
    icon: "sparkles",
  },
  {
    title: "De-shed Treatment",
    description:
      "Deep brush-out, de-shedding shampoo and conditioning treatment to reduce loose coat and leave fur soft and shiny.",
    duration: "2 – 2.5 hours",
    icon: "wind",
  },
  {
    title: "Bespoke Add-ons",
    description:
      "Blueberry facials, paw balm, teeth brushing, hypoallergenic shampoos and bow or bandana finishes available on request.",
    duration: "Add to any service",
    icon: "flower",
  },
];

export const VALUES = [
  {
    title: "One-on-One Care",
    text: "Only your pup is in the studio during their appointment. No queues, no other dogs, no stress.",
  },
  {
    title: "Cage-Free, Always",
    text: "We never crate or kennel. Pups rest on a soft mat between bath and blow-dry — at their own pace.",
  },
  {
    title: "Calm, Quiet Studio",
    text: "A private, sunlit boutique space designed to feel more like a sanctuary than a salon.",
  },
  {
    title: "Boutique Finish",
    text: "Premium products, breed-aware styling and a gentle hand — your pup leaves looking and feeling their best.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Emma & Coco",
    breed: "Cavoodle",
    quote:
      "Coco usually hates the groomer, but she trotted out of Barks & Co looking like a fluffy little cloud — and actually happy. The whole setup is so calm and beautiful.",
  },
  {
    name: "Liam & Bear",
    breed: "Golden Retriever",
    quote:
      "Bear's de-shed treatment was honestly life-changing for our couch. Gentle, patient, and obviously loves dogs. Won't go anywhere else.",
  },
  {
    name: "Sophie & Mochi",
    breed: "Shih Tzu",
    quote:
      "Easily the best grooming experience we've had. Mochi is shy, and being the only dog there made all the difference. He looks gorgeous.",
  },
  {
    name: "Ana & Pebbles",
    breed: "Mini Schnauzer",
    quote:
      "From the booking to the finish — every detail feels considered. Beautiful studio, beautiful work, beautiful pup.",
  },
];

export const FAQS = [
  {
    q: "How do I book an appointment?",
    a: "Barks & Co is currently operating with limited availability. To request an appointment, please join our waitlist by filling in the form on this page. We'll be in touch as soon as a spot becomes available for your pup.",
  },
  {
    q: "Where is the studio located?",
    a: "The studio is a private boutique grooming space in Auckland, New Zealand. To keep things calm and secure, the exact address is emailed to you once your appointment is confirmed.",
  },
  {
    q: "How often should my dog be groomed?",
    a: "Most coated breeds benefit from a full groom every 6 – 8 weeks, with a bath & tidy in between. Short-coated breeds can stretch to every 8 – 12 weeks. I'm happy to recommend a routine for your pup at your first visit.",
  },
  {
    q: "My dog is matted — can you still groom them?",
    a: "Yes, in most cases. Gentle de-matting is done where it's comfortable for your pup. Severe matting may require a shorter clip for their welfare — we'll always talk it through with you first.",
  },
  {
    q: "Do you take puppies?",
    a: "Absolutely — puppies are welcome from 12 weeks (and after their second vaccinations). The Puppy's First Groom is designed to be a gentle, positive introduction so they grow up loving grooming day.",
  },
  {
    q: "What if I need to cancel or reschedule?",
    a: "Please give at least 24 hours' notice via the booking system or by phone. As a one-on-one studio, late cancellations leave a spot empty that another pup could have enjoyed.",
  },
  {
    q: "How do I pay?",
    a: "Payment is taken in person at the end of the appointment — bank transfer, cash or card. A small deposit may be required for some services at the time of booking.",
  },
];
